/* Amanita Universe theme — storefront JS (v1.6.4) */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  var RM = window.matchMedia('(prefers-reduced-motion: reduce)');
  var FINE = window.matchMedia('(hover: hover) and (pointer: fine)');
  var cartRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';

  function setCartCount(n) {
    var cartLink = $('a[href="/cart"]') || $('a.iconbtn[href*="cart"]') || $('[data-open-drawer="cart"]');
    if (!cartLink) return;
    var badge = cartLink.querySelector('.iconbtn__n') || cartLink.querySelector('[data-cart-count]');
    n = Math.max(0, parseInt(n, 10) || 0);
    if (n <= 0) {
      if (badge) badge.remove();
      return;
    }
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'iconbtn__n num';
      cartLink.appendChild(badge);
    }
    badge.textContent = String(n);
    badge.hidden = false;
    badge.classList.remove('is-bump');
    void badge.offsetWidth;
    badge.classList.add('is-bump');
  }

  function refreshCartCount() {
    fetch(cartRoot + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setCartCount(cart.item_count); })
      .catch(function () {});
  }

  function atcFeedback(btn, doneLabel, revert) {
    if (!btn) return;
    var html = btn.getAttribute('data-html-cache') || btn.innerHTML;
    btn.setAttribute('data-html-cache', html);
    btn.style.minWidth = btn.offsetWidth + 'px';
    if (revert) {
      btn.removeAttribute('data-state');
      btn.innerHTML = html;
      btn.style.minWidth = '';
      return;
    }
    btn.setAttribute('data-state', 'load');
    btn.innerHTML = '<span class="btn__ind"><span class="spin"></span></span>';
  }

  function atcDone(btn, doneLabel) {
    if (!btn) return;
    var html = btn.getAttribute('data-html-cache') || btn.innerHTML;
    btn.setAttribute('data-state', 'done');
    btn.innerHTML = '<span class="btn__ind">' + (doneLabel || 'Added') + '</span>';
    setTimeout(function () {
      btn.removeAttribute('data-state');
      btn.innerHTML = html;
      btn.style.minWidth = '';
      btn.removeAttribute('data-html-cache');
    }, 1100);
  }

  /* Product media thumbs */
  var main = $('[data-mainimg]');
  $$('[data-thumb]').forEach(function (btn, i) {
    btn.addEventListener('click', function () {
      var src = btn.getAttribute('data-thumb');
      $$('[data-thumb]').forEach(function (b, j) {
        b.setAttribute('aria-current', i === j ? 'true' : 'false');
      });
      if (main && src) {
        main.src = src;
        main.srcset = '';
      }
    });
  });

  /* Qty steppers */
  $$('[data-qty]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = $('[data-qty-input]');
      if (!input) return;
      var next = Math.max(1, Math.min(20, (parseInt(input.value, 10) || 1) + parseInt(btn.getAttribute('data-qty'), 10)));
      input.value = next;
    });
  });

  /* Variant option buttons */
  var jsonEl = $('[data-product-json]');
  var variantInput = $('[data-variant-id]');
  if (jsonEl && variantInput) {
    var product = {};
    try { product = JSON.parse(jsonEl.textContent); } catch (e) {}
    var selected = {};
    (product.options || []).forEach(function (name, i) {
      selected[i] = (product.variants[0] && product.variants[0].options[i]) || null;
    });
    function syncSticky(match) {
      var stickyPrice = $('[data-sticky-price]');
      if (stickyPrice && match) {
        stickyPrice.textContent = (match.price / 100).toLocaleString(undefined, {
          style: 'currency',
          currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
        });
      }
      var stickyBtn = $('[data-sticky-atc]');
      if (stickyBtn && match) {
        stickyBtn.disabled = !match.available;
        if (!stickyBtn.hasAttribute('data-state')) {
          stickyBtn.textContent = match.available ? 'Add to cart' : 'Sold out';
        }
      }
    }
    $$('[data-option-value]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var wrap = btn.closest('[data-option-index]');
        var idx = parseInt(wrap.getAttribute('data-option-index'), 10);
        selected[idx] = btn.getAttribute('data-option-value');
        $$('[data-option-value]', wrap).forEach(function (b) {
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        var match = (product.variants || []).filter(function (v) {
          return v.options.every(function (opt, i) { return opt === selected[i]; });
        })[0];
        if (match) {
          variantInput.value = match.id;
          var priceWrap = $('[data-price-wrap] .price.num');
          if (priceWrap) {
            priceWrap.textContent = (match.price / 100).toLocaleString(undefined, {
              style: 'currency',
              currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
            });
          }
          var atc = $('[data-atc]:not([data-sticky-atc])');
          if (atc) {
            atc.disabled = !match.available;
            atc.textContent = match.available ? 'Add to cart' : 'Sold out';
          }
          syncSticky(match);
        }
      });
    });
  }

  /* ATC — honest success/fail + cart count from cart.js */
  var form = $('#product-form');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[data-atc]');
      var id = variantInput && variantInput.value;
      var qty = ($('[data-qty-input]') && $('[data-qty-input]').value) || 1;
      if (!id || (btn && btn.disabled)) return;
      var stickyBtn = $('[data-sticky-atc]');
      atcFeedback(btn);
      if (stickyBtn && stickyBtn !== btn) atcFeedback(stickyBtn);
      fetch(cartRoot + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(qty) }] })
      })
        .then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok) throw data;
            return data;
          });
        })
        .then(function () {
          atcDone(btn, 'Added');
          if (stickyBtn && stickyBtn !== btn) atcDone(stickyBtn, 'Added');
          refreshCartCount();
        })
        .catch(function () {
          atcFeedback(btn, null, true);
          if (stickyBtn && stickyBtn !== btn) atcFeedback(stickyBtn, null, true);
          if (btn) {
            btn.setAttribute('data-state', 'done');
            btn.innerHTML = '<span class="btn__ind">Try again</span>';
            setTimeout(function () {
              btn.removeAttribute('data-state');
              btn.innerHTML = btn.getAttribute('data-html-cache') || 'Add to cart';
              btn.style.minWidth = '';
            }, 1400);
          }
        });
    });
  }
  $$('[data-sticky-atc]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (!form) return;
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    });
  });

  /* #10 reveal + cascade */
  function reveal(nodes) {
    nodes = Array.prototype.slice.call(nodes || []);
    if (!nodes.length) return;
    if (RM.matches || !('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('is-in');
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
    nodes.forEach(function (n, i) {
      n.setAttribute('data-reveal', '');
      if (n.classList.contains('card') || n.classList.contains('bcard') || n.classList.contains('path')) {
        n.style.setProperty('--rd', Math.min(i % 8, 7) * 70 + 'ms');
      } else {
        n.style.setProperty('--rd', Math.min(i, 4) * 50 + 'ms');
      }
      io.observe(n);
    });
  }
  reveal(document.querySelectorAll('[data-r], .card, .sec, .bcard, .path'));

  /* #9 hero entrance */
  var hero = document.querySelector('.hero');
  if (hero && !RM.matches) {
    hero.setAttribute('data-hero-motion', '');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { hero.classList.add('is-hero-in'); });
    });
  } else if (hero) {
    hero.classList.add('is-hero-in');
  }

  /* #15 parallax hero image — desktop + fine pointer only */
  var heroImg = hero && hero.querySelector('.hero__media img');
  var DESK = window.matchMedia('(min-width: 941px)');
  var parallaxOn = false;
  var onParallaxScroll = null;
  function canParallax() {
    return !!(heroImg && FINE.matches && DESK.matches && !RM.matches);
  }
  function clearParallax() {
    if (!heroImg) return;
    if (parallaxOn && onParallaxScroll) {
      window.removeEventListener('scroll', onParallaxScroll);
    }
    parallaxOn = false;
    onParallaxScroll = null;
    heroImg.removeAttribute('data-parallax');
    heroImg.style.transform = '';
  }
  function enableParallax() {
    if (!heroImg || parallaxOn) return;
    heroImg.setAttribute('data-parallax', '');
    onParallaxScroll = function () {
      var y = Math.min(window.scrollY * 0.22, 56);
      heroImg.style.transform = 'translate3d(0,' + y + 'px,0) scale(1.1)';
    };
    onParallaxScroll();
    window.addEventListener('scroll', onParallaxScroll, { passive: true });
    parallaxOn = true;
  }
  function syncParallax() {
    if (canParallax()) enableParallax();
    else clearParallax();
  }
  syncParallax();
  if (typeof FINE.addEventListener === 'function') {
    FINE.addEventListener('change', syncParallax);
    DESK.addEventListener('change', syncParallax);
    RM.addEventListener('change', syncParallax);
  } else if (typeof FINE.addListener === 'function') {
    FINE.addListener(syncParallax);
    DESK.addListener(syncParallax);
    RM.addListener(syncParallax);
  }

  /* PDP zoom */
  var stage = document.querySelector('.pdp__main');
  var sim = stage && stage.querySelector('img');
  if (stage && sim && FINE.matches && !RM.matches) {
    stage.addEventListener('mouseenter', function () { stage.setAttribute('data-zoom', ''); });
    stage.addEventListener('mousemove', function (e) {
      var r = stage.getBoundingClientRect();
      sim.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
    });
    stage.addEventListener('mouseleave', function () {
      stage.removeAttribute('data-zoom');
      sim.style.transformOrigin = '';
    });
  }

  /* #12 sticky ATC spring */
  var sticky = $('[data-stickybuy]');
  var buyAnchor = $('.qtyrow') || $('.pdp__buy');
  if (sticky && buyAnchor) {
    document.body.classList.add('has-sticky');
    if (RM.matches) {
      sticky.classList.add('is-on');
      sticky.setAttribute('aria-hidden', 'false');
    } else if ('IntersectionObserver' in window) {
      var sio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var show = !en.isIntersecting;
          sticky.classList.toggle('is-on', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        });
      }, { threshold: 0, rootMargin: '0px' });
      sio.observe(buyAnchor);
    } else {
      sticky.classList.add('is-on');
    }
  }

  document.addEventListener('au:filter-start', function () {
    var grid = document.querySelector('[data-grid]');
    if (!grid || RM.matches) return;
    grid.setAttribute('data-busy', '');
  });
  document.addEventListener('au:filter-end', function () {
    var grid = document.querySelector('[data-grid]');
    if (grid) grid.removeAttribute('data-busy');
  });

  /* Mega menu — hover opens; <button> toggles on click; <a> navigates (Shop → /collections) */
  $$('[data-mega]').forEach(function (li) {
    var trigger = li.querySelector('button[aria-haspopup], a[aria-haspopup]');
    if (!trigger) return;
    var closeTimer;
    function open() {
      clearTimeout(closeTimer);
      $$('[data-mega]').forEach(function (other) {
        if (other === li) return;
        other.removeAttribute('data-open');
        var ot = other.querySelector('button[aria-haspopup], a[aria-haspopup]');
        if (ot) ot.setAttribute('aria-expanded', 'false');
      });
      li.setAttribute('data-open', '');
      trigger.setAttribute('aria-expanded', 'true');
    }
    function shut() {
      closeTimer = setTimeout(function () {
        li.removeAttribute('data-open');
        trigger.setAttribute('aria-expanded', 'false');
      }, 130);
    }
    li.addEventListener('mouseenter', open);
    li.addEventListener('mouseleave', shut);
    trigger.addEventListener('click', function (e) {
      /* Links (Shop) navigate; buttons (Learn) toggle the panel */
      if (trigger.tagName === 'A') return;
      e.preventDefault();
      if (li.hasAttribute('data-open')) shut();
      else open();
    });
    li.addEventListener('focusout', function (e) {
      if (!li.contains(e.relatedTarget)) shut();
    });
  });

  /* Mobile nav drawer */
  var scrim = $('[data-scrim]');
  function openDrawer(id) {
    var d = $('[data-drawer="' + id + '"]');
    if (!d) {
      if (id === 'cart') window.location.href = cartRoot + 'cart';
      return;
    }
    d.hidden = false;
    d.setAttribute('data-open', '');
    if (scrim) {
      scrim.hidden = false;
      scrim.setAttribute('data-open', '');
    }
    document.documentElement.classList.add('has-drawer');
  }
  function closeDrawer() {
    $$('.drawer[data-open]').forEach(function (d) {
      d.removeAttribute('data-open');
      d.hidden = true;
    });
    if (scrim) {
      scrim.removeAttribute('data-open');
      scrim.hidden = true;
    }
    document.documentElement.classList.remove('has-drawer');
  }
  window.A = window.A || {};
  window.A.openDrawer = openDrawer;
  window.A.closeDrawer = closeDrawer;

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-open-drawer]');
    if (openBtn) {
      e.preventDefault();
      openDrawer(openBtn.getAttribute('data-open-drawer'));
      return;
    }
    if (e.target.closest('[data-close]') || e.target === scrim) {
      closeDrawer();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* Collection facets */
  var facetsForm = $('[data-facets]');
  if (facetsForm) {
    var toolbar = facetsForm.closest('.toolbar');
    function syncFacetOpen() {
      if (!toolbar) return;
      var any = $$('details.facet[open]', toolbar).length > 0;
      if (any) toolbar.setAttribute('data-facet-open', '');
      else toolbar.removeAttribute('data-facet-open');
    }
    $$('details.facet', facetsForm).forEach(function (det) {
      det.addEventListener('toggle', function () {
        if (det.open) {
          $$('details.facet', facetsForm).forEach(function (other) {
            if (other !== det) other.open = false;
          });
        }
        syncFacetOpen();
      });
    });
    facetsForm.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || t.type !== 'checkbox') return;
      document.dispatchEvent(new CustomEvent('au:filter-start'));
      facetsForm.submit();
    });
    document.addEventListener('click', function (e) {
      if (!facetsForm.contains(e.target) && toolbar && !toolbar.contains(e.target)) {
        $$('details.facet[open]', facetsForm).forEach(function (d) { d.open = false; });
        syncFacetOpen();
      }
    });
  }

  /* Sort — Shopify native via URL; Top rated = client reorder of current page */
  var sortSel = $('[data-sort]');
  if (sortSel) {
    sortSel.addEventListener('change', function () {
      var v = sortSel.value;
      if (!v) return;
      if (v === '__rating__' || sortSel.options[sortSel.selectedIndex].getAttribute('data-client-sort') === 'rating') {
        sortGridByRating();
        return;
      }
      window.location.href = v;
    });
  }

  function sortGridByRating() {
    var grid = $('[data-grid]');
    if (!grid) return;
    var cards = $$('.card', grid);
    if (!cards.length) return;
    cards.sort(function (a, b) {
      var arc = parseInt(a.getAttribute('data-rc') || '0', 10);
      var brc = parseInt(b.getAttribute('data-rc') || '0', 10);
      var ar = arc > 0 ? 1 : 0;
      var br = brc > 0 ? 1 : 0;
      if (br !== ar) return br - ar;
      var art = parseFloat(a.getAttribute('data-rt') || '0');
      var brt = parseFloat(b.getAttribute('data-rt') || '0');
      if (brt !== art) return brt - art;
      if (brc !== arc) return brc - arc;
      var aa = parseInt(a.getAttribute('data-avail') || '0', 10);
      var ba = parseInt(b.getAttribute('data-avail') || '0', 10);
      return ba - aa;
    });
    cards.forEach(function (c) { grid.appendChild(c); });
  }

})();
